<template>
  <!-- <pre>{{ currentPicObj }}</pre> -->
  <div class="imagesDetails">
    <div class="imageSearch">
      <StickySearch />
    </div>
    <DetailPageSkeleton
v-if="!dataError && (clientLoading || !(currentPicObj && Object.keys(currentPicObj).length > 0))"
      class="skeleton" />
    <div v-else-if="!dataError">
      <div class="imageblockpage screen">
        <div class="image-detail-block">
          <div ref="imageAreaRef" class="image-area">
            <div class="icon-button-group image-area-button">
              <div class="icon-button-group-left">
                <div class="icon-button icon-button-favorite" @click="handlePicCollect">
                  <icon-favorite class="icon" :class="[{ 'is-favorite': currentPicObj.collect }]" />
                  <div class="button-title">{{ currentPicObj.collectCount }}</div>
                </div>

                <CommonShareDropDown ref="commonShareDropDownMRef">
                  <div class="icon-button-1">
                    <img class="icon-1" src="~/images/share@2x.webp" alt="icon">
                  </div>
                </CommonShareDropDown>

                <!-- h5 -->
                <div v-if="mine" class="icon-button-1" @click="handlePicDelete">
                  <icon-trash class="icon-1" />
                </div>
                <el-popover
v-else ref="reportPopoverMRef" placement="bottom-end" :width="183" :show-arrow="false"
                  popper-class="popperClass" :persistent="false" :teleported="false" :popper-style="{
                    fontFamily: 'SFPro,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif',
                    zIndex: 1,
                  }" trigger="click" content="this is content, this is content, this is content">
                  <template #reference>
                    <div class="icon-button-1">
                      <img class="icon-1" src="~/images/report@2x.webp" alt="icon">
                    </div>
                  </template>
                  <div class="popoverList">
                    <div class="popoverItem popoverItemReport" @click="handleReport">
                      <span> {{ $t("detail.report") }}</span>
                    </div>
                  </div>
                </el-popover>

              </div>
              <div @click.stop>
                <el-popover
ref="downloadPopoverMRef" placement="bottom" trigger="click" popper-class="download-btn"
                  :teleported="false" :hide-after="0" :persistent="false">
                  <template #default>
                    <div class="download">
                      <span @click="download('JPG')">{{ $t('detail.jpg') }}</span>
                      <span @click="download('PNG')">{{ $t('detail.png') }}</span>
                    </div>
                  </template>
                  <template #reference>
                    <div class="icon-button-2">
                      <img v-if="!downloading" class="icon-2" src="~/images/download@2x.webp" alt="icon">
                      <div v-if="downloading" class="case-item-loading -samll-circle" />
                    </div>
                  </template>
                </el-popover>
              </div>
            </div>
            <!-- <img class="image" :src="currentPicObj.imageUrl" :alt="currentPicObj.title" loading="lazy"
              decoding="async" @click="lookLargeImage(currentPicObj.imageUrl)" /> -->
            <img
v-if="!currentPicObj.mainSrc" class="image" :src="currentPicObj.imageUrl" :alt="currentPicObj.title"
              loading="lazy" decoding="async" @click="lookLargeImage()">
            <img
v-else class="image" :src="`${currentPicObj.mainSrc}?w=${currentPicObj.width}`"
              :alt="currentPicObj.categoryName" :sizes="imgResponseSizes(currentPicObj.width, currentPicObj.height)"
              :srcset="$newResponseSrcset(currentPicObj.mainSrc, currentPicObj.width)" @click="lookLargeImage()">
            <!-- <div v-if="currentPicObj.imageUrl" class="image"
            :style="{ 'background-image': `url(${currentPicObj.imageUrl})` }"
            @click="lookLargeImage(currentPicObj.imageUrl)">
          </div>
          <div class="emptyimage" v-else></div> -->
          </div>
          <div class="image-card">
            <div class="icon-button-group">
              <div class="icon-button-group-left">
                <div class="icon-button" @click="handlePicCollect">
                  <icon-favorite class="icon" :class="[{ 'is-favorite': currentPicObj.collect }]" />
                  <div class="button-title">{{ currentPicObj.collectCount }}</div>
                </div>

                <CommonShareDropDown ref="commonShareDropDownRef">
                  <div class="icon-button-1">
                    <img class="icon-1" src="~/images/share@2x.webp" alt="icon">
                    <div class="button-title-1">{{ $t("detail.share") }}</div>
                  </div>
                </CommonShareDropDown>
              </div>

              <!-- pc -->
              <div v-if="mine" class="icon-button-1" @click="handlePicDelete">
                <icon-trash class="icon-1" />
              </div>

              <el-popover
v-else ref="reportPopoverRef" placement="bottom-start" :width="183" :show-arrow="false"
                popper-class="popperClass" :persistent="false" :teleported="false" :popper-style="{
                  fontFamily: 'SFPro,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif',
                  border: 'none'
                }" trigger="click">
                <template #reference>
                  <div class="icon-button-2">
                    <img class="icon-2" src="~/images/report@2x.webp" alt="icon">
                  </div>
                </template>
                <div class="popoverList">
                  <div class="popoverItem popoverItemReport" @click="handleReport">
                    <span> {{ $t("detail.report") }}</span>
                  </div>
                </div>
              </el-popover>
            </div>
            <div class="image-info">
              <div class="user-block">
                <NuxtLinkLocale :to="`/images-photos/creator/${currentPicObj?.uid}`">
                  <el-avatar class="user-headshot" :src="currentPicObj?.userInfoVO?.avatarUrl" />
                </NuxtLinkLocale>
                <div class="user-info">
                  <NuxtLinkLocale :to="`/images-photos/creator/${currentPicObj?.uid}`">
                    <div class="user-name">
                      {{ currentPicObj?.userInfoVO?.nickName }}
                    </div>
                  </NuxtLinkLocale>
                  <div class="user-detail">
                    {{ currentPicObj?.userInfoVO?.publishCount }}
                    {{ $t("detail.publishCount") }}
                  </div>
                </div>
              </div>
              <div class="gap22" />
              <div class="title">
                <h1 class="image-title sfpro-regular-normal-black-15px">
                  {{ currentPicObj.title }}
                </h1>
              </div>
              <div class="gap10" />
              <div class="prompt-block">
                <p class="prompt sfpro-regular-normal-black-15px">
                  <span class="sfpro-regular-normal-black-15px">{{ $t('detail.prompt') }}: </span><span
                    class="sfpro-regular-normal-black-13px">{{
                      currentPicObj.originalPrompt
                    }}</span>
                </p>
              </div>
              <div class="gap20-1" />
              <div class="sub-button-group">
                <!-- <div :class="[`sub-button`, subButton1Props.className || ``]" @click="handleToCreate">
                  <div class="button-title-2 sfpro-medium-blue-16px">
                    {{ $t("detail.goGenerate") }}
                  </div>
                </div> -->
                <div style="width: 100%" @click.stop>
                  <div
ref="contentDiv" class="icon-button" style="
                      width: 100%;
                      border: 1px solid rgba(87, 126, 255, 1);">
                    <el-popover
ref="popoverMoreFeaturesRef" :trigger="!isShowPC ? 'click' : 'click'" :offset="11"
                      placement="top" :popper-style="{
                        width: moreFeaturesPopoverWidth + 'px',
                        padding: '10px 15px',
                        zIndex: 1,
                        borderRadius: '10px',
                        boxShadow: '0px 2px 20px 0px rgba(0,0,0,0.1)',
                        marginBottom: '10px',
                        border: 'none'
                      }" :show-arrow="false" persistent @before-enter="showPopover">
                      <!-- @click.prevent="emit('re-generate')" -->
                      <div class="more-format-btn" @click.stop.prevent="handleToCreate">
                        <img class="more-format-btn-img" src="~/images/more-1.webp" alt="">
                        <div class="more-format-btn-text">{{ $t('mutualExposure.reGenerate') }}</div>
                      </div>
                      <div class="more-format-btn" @click.stop.prevent="goChangeBackground">
                        <img class="more-format-btn-img" src="~/images/more-2.webp" alt="">
                        <div class="more-format-btn-text">{{ $t('mutualExposure.changeBackground') }}</div>
                      </div>
                      <div class="more-format-btn" @click.stop.prevent="goChangeWatermark">
                        <img class="more-format-btn-img" src="~/images/more-3.webp" alt="">
                        <div class="more-format-btn-text">{{ $t('mutualExposure.removeWatermark') }}</div>
                      </div>
                      <div class="more-format-btn" @click.stop.prevent="goPhotoEnhance">
                        <img class="more-format-btn-img" src="~/images/more-4.webp" alt="">
                        <div class="more-format-btn-text">{{ $t('mutualExposure.enhance') }}</div>
                      </div>
                      <template #reference>
                        <div ref="moreFeaturesRef" class="button-title-2 sfpro-medium-blue-16px">
                          {{ $t('mutualExposure.moreFeatures') }}</div>
                      </template>
                    </el-popover>
                  </div>
                </div>

              </div>
              <div class="gap16" />
              <div class="primary-button">
                <div class="download-free" @click="download('PNG')">
                  <span>{{ $t("detail.downloadText") }}</span>
                  <div v-if="downloading" class="case-item-loading -circle" />
                </div>
                <div @click.stop>
                  <el-popover
ref="downloadPopoverRef" placement="bottom" trigger="click" popper-class="download-btn"
                    :teleported="false" :hide-after="0" :persistent="false" :popper-style="{
                      border: 'none'
                    }"
                    @before-leave="handleHidePoper"
                    @before-enter="handleShowPoper">

                    <template #default>
                      <div class="download">
                        <span @click="download('JPG')">{{ $t('detail.jpg') }}</span>
                        <span @click="download('PNG')">{{ $t('detail.png') }}</span>
                      </div>
                    </template>
                    <template #reference>
                      <div class="download-type">
                        <div
                          class="triangle"
                          :class="{ expand: isExpand, unExpand: !isExpand }" />
                      </div>
                    </template>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="gap50" />
      </div>


      <!-- 展示条件 非创作者自己的图片 且 有相似图片或相似词条 -->
      <!-- StickySearch需要一直sticky， 所以要将.content-container放到.imagesDetails里 -->
    </div>
    <!--  && !mine -->
    <div v-if="!clientLoading && !dataError" class="content-container">
      <div class="content-wrap">
        <div class="scroll-tag-warpper">
          <ScrollableView>
            <!-- <NuxtLinkLocale
v-for="item in pageData?.likeWords" :key="item" class="tag"
              :to="`/photos/images/${picTitleToHyphen(item)}`" @click="setHistory(item)">
              {{ item }}
            </NuxtLinkLocale> -->
            <NuxtLinkLocale
v-for="(item, index) in pageData?.likeWords" :key="item" class="tag" :title="item"
              :to="`/photos/images/${picTitleToHyphen(item)}`" @click="setHistory(item)"
              @mouseenter="handleMouseEnter($event, index)">
              <div v-if="!(tagPopover[index])" class="popoverTag">
                <span>{{ item }}</span>
              </div>
              <el-popover
popper-class="label-tag-popover" placement="top" trigger="hover" :content="item" effect="dark"
                :popper-style="{
                  background: '#2a2a2a',
                  borderRadius: '5px',
                  width: item.width,
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#ffffff',
                  lineHeight: '18px',
                  textAlign: 'center',
                  padding: '10px',
                  border: 0
                }">
                <template #reference>
                  <div v-if="tagPopover[index]" class="popoverTag">
                    <span>{{ item }}</span>
                  </div>
                </template>
              </el-popover>
            </NuxtLinkLocale>
          </ScrollableView>
        </div>

        <section class="pic-list-container">
          <div v-if="samePicData?.galleryList?.length">
            <MasonryWall :items="samePicData.galleryList">
              <template #default="{ item: pic, index: index }">
                <MasonryWallThumbnail
:key="pic?.taskId" :loading-method="index < preloadThreshold ? 'auto' : 'lazy'"
                  class="gallery-masonry-item" :index="index" :pic="pic" />
              </template>
            </MasonryWall>

            <el-pagination
v-model:current-page="currentPage" class="pagination" background layout="prev, pager, next"
              :page-size="30" :total="pageData?.galleryCount" :pager-count="5" hide-on-single-page
              prev-icon="icon-page-prev" next-icon="icon-page-next" @current-change="handleChangePage" />
          </div>
        </section>
      </div>
    </div>
  </div>
  <div v-if="!(currentPicObj && Object.keys(currentPicObj).length > 0)" class="searchEmptyResult">
    <EmptyForSearch />
  </div>

  <!-- eslint-disable-next-line vue/no-multiple-template-root -->
  <ClientOnly>
    <ViewLargeImage v-model:visible="viewShow" :data-info="bigImgInfo" />

    <Dialog v-model="reportVisible">
      <template #header>
        <div class="reportVisibleTitle">
          <span class="title">{{ $t("report.title") }}</span>
          <span class="desc">{{ $t("report.subTitle1") }}</span>
        </div>
      </template>
      <ReportAction :task-id="taskId" @close="closeDialogFun" />
    </Dialog>

    <DialogDeletePic v-model:visible="deleteVisible" :task-id="taskId" @delete="goPublisherHome" />
  </ClientOnly>
</template>

<script setup>
import ReportAction from '~/components/dialog/ReportAction.vue';

import { goRouterPage, RouterPageConst } from '@/utils/routes_mapping.js';

defineI18nRoute({
  paths: {
    fr: '/photos-détail/[title]-[taskId]',
    es: '/fotos-detalle/[title]-[taskId]',
    ja: '/写真-詳細/[title]-[taskId]',
    pt: '/fotos-detalhe/[title]-[taskId]',
  },
});

const { $signUpDialog, $analytic, $showErrorToast, $isMobile, $isTablet, $isDesktop } = useNuxtApp();
const { setHistory } = useSearchHistory();
const { t, locale } = useI18n();
const localePath = useLocalePath();
const route = useRoute();
const router = useRouter();
const query = route.query;

const params = `${route.params.title}-${route.params.taskId}`;
const parts = params.split('-');
// 目前路径为title-taskId，后续路径有变更再额外处理
const taskId = parts.pop();
const title = picTitleToWhitespace(parts.join('-'));

const tagPopover = ref([]);

const pageData = ref({});
const samePicData = ref({});
const currentPicObj = ref({});
const alternateMeta = ref([]);
const mine = ref(false);

const moreFeaturesRef = ref(null);
const moreFeaturesPopoverWidth = ref(0);
// const moreFeaturesPopoverWidth = computed(() => {
//   if(moreFeaturesRef.value){
//     return moreFeaturesRef.value?.offsetWidth + 40
//   }
// });
const imageAreaRef = ref(null);
const imgResponseSizes = () => {
  const sizes = '(min-width 999px) calc(100vw - 514px), (max-width 999px) calc(100vw - 80px), (max-width 767px) calc(100vw - 30px), (min-width 375px) calc(100vw - 30px)';
  return sizes;
};


const viewShow = ref(false);
const lookLargeImage = () => {
  $analytic.log('gallerys_details_full_shows');
  viewShow.value = true;
  if (currentPicObj.value.mainSrc) {
    bigImgInfo.value.url = `${currentPicObj.value.mainSrc}?w=${currentPicObj.value.width}`;
  } else {
    bigImgInfo.value.url = currentPicObj.value.imageUrl;
  }

  // bigImgInfo.value.url = url;
};
const bigImgInfo = ref({
  type: 'image',
  prompt: '',
});

const pageQuery = {
  taskId,
  language: locale.value,
};
const samePicQuery = {
  page: 1,
  keyWords: title,
  sort: 3,
  language: locale.value,
};

const clientLoading = ref(false);
const dataError = ref(false);

const preloadThreshold = 4;

if (import.meta.client) {
  clientLoading.value = true;
  loadData().then(() => {
    clientLoading.value = false;
    useHead({
      title: getMeta().title,
      meta: getMeta().meta,
    });
  }).catch(() => {
    clientLoading.value = false;
  });
} else {
  await loadData();
}
async function loadData () {
  try {
    const [_pageData, _sameData] = await Promise.all([useGetGalleryInfoDetail(pageQuery), useGetGalleryPage(samePicQuery)]);
    pageData.value = _pageData.data;

    if (_pageData.data instanceof Array) {
      dataError.value = true;
      throw false;
    }

    tagPopover.value = _pageData.data?.likeWords.map(() => (false));
    for (const row of pageData.value.otherGallery) {
      if (row.title == null) {
        continue;
      }
      const title = encodeURIComponent(row.title.replaceAll(/\s+/g, '-'));
      const href = `${useRuntimeConfig().public.domain[row.language]}${routeConstMapping[row.language].GalleryDetail}/${title}-${taskId}`;

      alternateMeta.value.push({
        rel: 'alternate',
        hreflang: row.language,
        href,
      });

      // 如果是en，新增
      if (row.language === 'en') {
        alternateMeta.value.push({
          rel: 'alternate',
          hreflang: 'x-default',
          href,
        });
      }
    }
    _sameData.data.galleryList = useRatio([..._sameData.data.galleryList]).filter(item => item.taskId !== pageQuery.taskId);
    samePicData.value = _sameData.data;
    if (import.meta.client) {
      nextTick(() => {
        handleGetCollect();
        handleGetCollectGalleryListStatus();
      });
    }
    currentPicObj.value = pageData.value?.galleryList?.[0];
    mine.value = currentPicObj.value?.mine || false;
  } catch (error) {
    if (dataError.value) {
      throw createError({
        statusCode: 404,
        message: 'not found',
        fatal: true,
      });
    }
    console.log('PhotoDetail: ', error);
  }
}

const handleToCreate = () => {
  const { ratio, originalPrompt, model } = currentPicObj.value;
  const item = {
    ratio,
    prompt: originalPrompt,
    model,
  };
  window.localStorage.setItem('txtToImageHistory', JSON.stringify(item));
  goRouterPage(RouterPageConst.TextToImage, locale.value, null, true);
};

const favLock = ref(false);
const handlePicCollect = async () => {
  if (!User.getInstance.isLogin.value) {
    $signUpDialog();
    return;
  }
  if (favLock.value) return;
  const originCollect = unref(currentPicObj.value.collect);
  const originCount = unref(currentPicObj.value.collectCount);
  try {
    favLock.value = true;
    if (originCollect) {
      await useUncollectPic({ taskId });
      currentPicObj.value.collectCount -= 1;
    } else {
      await useCollectPic({ taskId });
      currentPicObj.value.collectCount += 1;
    }
    favLock.value = false;
    currentPicObj.value.collect = !currentPicObj.value.collect;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    currentPicObj.value.collect = originCollect;
    currentPicObj.value.collectCount = originCount;
    //
  }
};

const deleteVisible = ref(false);
const handlePicDelete = () => {
  deleteVisible.value = true;
};
const goPublisherHome = () => {
  const pId = useCookie('publisherId');
  const path = localePath({
    name: routesName.publisher,
    params: { id: pId.value },
  });
  router.replace(path);
};

// const handleEnhance = () => {
//   if (!User.getInstance.isLogin.value) {
//     $signUpDialog();
//     return;
//   }
//   window.localStorage.setItem(
//     "imageUrlToEnhance",
//     currentPicObj.value.imageUrl
//   );
//   // goRouterPage(RouterPageConst.EnhanceImage, locale.value, true);
// };

// const handleEnhance = () => {
//   if (!User.getInstance.isLogin.value) {
//     $signUpDialog();
//     return;
//   }
//   window.localStorage.setItem(
//     'imageUrlToEnhance',
//     currentPicObj.value.imageUrl
//   );
//   // goRouterPage(RouterPageConst.EnhanceImage, locale.value, true);
// };

const isExpand = ref(false);

const handleHidePoper = () => {
  isExpand.value = false;
};

const handleShowPoper = () => {
  isExpand.value = true;
};

// 下载多格式文件
const downloading = ref(false);
const downloadRef = ref(null);
async function download (type) {
  if (downloading.value) return;
  if (!User.getInstance.isLogin.value) {
    $signUpDialog();
    return;
  }
  let fileUrl = null;
  downloading.value = true;
  if (type == 'JPG') {
    if (!currentPicObj.value.jpgResultUrl) {
      if (downloadRef.value) {
        downloadRef.value.hide();
      }
      try {
        const resp = await useConvertImage({ type: 1, taskIds: currentPicObj.value.taskId });
        await fetchDownloadFile(resp.data[0]);
        downloading.value = false;
      } catch (err) {
        console.log('Download: ', err);
        downloading.value = false;
        $showErrorToast(t('detail.download'));
      }
    } else {
      fileUrl = currentPicObj.value.jpgResultUrl;
      await fetchDownloadFile(fileUrl);
      downloading.value = false;
    }
  } else {
    fileUrl = currentPicObj.value.imageUrl;
    await fetchDownloadFile(fileUrl);
    downloading.value = false;
  }
};

const fetchDownloadFile = async (url) => {
  const fileName = `GStory_${Math.ceil((+new Date()) / 1000)}${url.endsWith('png') ? '.png' : '.jpg'}`;
  try {
    const blob = await fetch(url)
      .then(response => response.blob());
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    setTimeout(() => {
      link.remove();
    }, 0);
  } catch (error) {
    console.error('download error:', error);
  }
};
const closeDialogFun = () => {
  reportVisible.value = false;
};

// const subButton1Props = ref({ className: 'sub-button-1' });
// const subButton2Props = ref({ className: 'sub-button-1' });

const reportVisible = ref(false);
const handleReport = () => {
  if (!User.getInstance.isLogin.value) {
    $signUpDialog();
    return;
  }
  reportVisible.value = true;
};

const getMeta = () => {
  const platform = query?.platform;

  if (currentPicObj.value) {
    if (platform === 'twitter' || platform === 'facebook') {
      const nickName = currentPicObj.value.userInfoVO.nickName;
      const title = t('meta.socialTitle').replace('<xx1>', nickName);
      const description = t('meta.socialDescription').replace('<xx1>', nickName);
      return {
        title,
        meta: [
          { name: 'description', content: description },
          { name: 'keywords', content: description },
          { property: 'og:image', content: currentPicObj.value.imageUrl },
          { property: 'og:title', content: title },
          { property: 'og:description', content: description },
          { property: 'og:site_name', content: 'GStory' },
          { property: 'og:type', content: 'website' },
          { property: 'og:url', content: currentPicObj.value.routerUrl },
        ],
      };
    }
    return {
      title: currentPicObj.value.title,
      meta: [
        { name: 'description', content: currentPicObj.value.originalPrompt },
        { name: 'keywords', content: currentPicObj.value.originalPrompt }, // TODO: 后续优化
        { property: 'og:image', content: currentPicObj.value.imageUrl },
        { property: 'og:title', content: currentPicObj.value.title }, // TODO: 后续优化
        {
          property: 'og:description',
          content: currentPicObj.value.originalPrompt,
        }, // TODO: 后续优化
        { property: 'og:site_name', content: 'GStory' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: currentPicObj.value.routerUrl },
      ],
    };
  }
  return {
    title: t('meta.404'),
    meta: [],
  };
};

useHead({
  title: getMeta().title,
  meta: getMeta().meta,
  link: alternateMeta.value,
});
const contentDiv = ref(null);
const popoverWidth = ref(233);

let resizeObserver = null;
if (import.meta.client) {
  resizeObserver = new ResizeObserver(() => {
    if (contentDiv.value) {
      popoverWidth.value = contentDiv.value?.offsetWidth;
    }
  });
}
if (import.meta.server) {
  if (moreFeaturesRef.value) {
    moreFeaturesPopoverWidth.value = moreFeaturesRef.value?.offsetWidth + 40;
  }
}


const showPopover = () => {
  if (moreFeaturesRef.value) {
    moreFeaturesPopoverWidth.value = moreFeaturesRef.value?.offsetWidth + 40;
  }
};
const handleResize = () => {
  moreFeaturesPopoverWidth.value = moreFeaturesRef.value?.offsetWidth + 40;
};

const reportPopoverRef = ref(null);
const reportPopoverMRef = ref(null);
const downloadPopoverMRef = ref(null);
const downloadPopoverRef = ref(null);
const popoverMoreFeaturesRef = ref(null);
const commonShareDropDownRef = ref(null);
const commonShareDropDownMRef = ref(null);

const handleScroll = () => {
  // dropdownHotNewRef.value.handleClose();

  if (downloadPopoverRef.value) {
    downloadPopoverRef.value?.hide();
  }

  if (reportPopoverRef.value) {
    reportPopoverRef.value?.hide();
  }

  if (reportPopoverMRef.value) {
    reportPopoverMRef.value?.hide();
  }

  if (downloadPopoverMRef.value) {
    downloadPopoverMRef.value?.hide();
  }

  if (popoverMoreFeaturesRef.value) {
    popoverMoreFeaturesRef.value?.hide();
  }

  if (commonShareDropDownRef.value) {
    commonShareDropDownRef.value?.handlePopoverClose();
  }

  if (commonShareDropDownMRef.value) {
    commonShareDropDownMRef.value?.handlePopoverClose();
  }
};

const handleMouseEnter = (e, index) => {
  if (e.target.clientWidth < 302) {
    tagPopover.value[index] = false;
  } else {
    tagPopover.value[index] = true;
  }
};


const handleGetCollect = async () => {
  await useImageListCollectStatus().setGalleryList(pageData.value?.galleryList);
  const result = await useImageListCollectStatus().getGalleryList;
  // pageData.value.galleryList = result;
  currentPicObj.value = result?.[0];
};

const handleGetCollectGalleryListStatus = async () => {
  await useImageListCollectStatus().setGalleryList(samePicData.value?.galleryList);
  const result = await useImageListCollectStatus().getGalleryList;
  samePicData.value.galleryList = result;
};

onMounted(async () => {
  if (contentDiv.value && resizeObserver) {
    resizeObserver.observe(contentDiv.value);
  }
  if (User.getInstance.isLogin.value) {
    if (Array.isArray(samePicData.value?.galleryList) && Array.isArray(pageData.value?.galleryList)) {
      nextTick(() => {
        handleGetCollect();
        handleGetCollectGalleryListStatus();
      });
    }
  }

  window.addEventListener('resize', handleResize);
  window.addEventListener('scroll', handleScroll);
  $analytic.log('gallerys_details_shows');
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('scroll', handleScroll);
});
const isShowPC = computed(() => {
  if ($isMobile() || $isTablet()) {
    return false;
  } else if ($isDesktop()) {
    return true;
  }
  return true; // 默认返回true
});

const goChangeBackground = () => {
  if (!User.getInstance.isLogin.value) {
    $signUpDialog();
    return;
  }

  localStorage.setItem('waitUploadRemoveBgImg', JSON.stringify(currentPicObj.value.imageUrl));
  goRouterPage(RouterPageConst.RemoveBackgroundImage, locale.value, null, true);
};


const goChangeWatermark = () => {
  if (!User.getInstance.isLogin.value) {
    $signUpDialog();
    return;
  }

  localStorage.setItem('waitUploadRemoveMkImg', JSON.stringify(currentPicObj.value.imageUrl));
  goRouterPage(RouterPageConst.RemoveWatermarkImage, locale.value, null, true);
};


const goPhotoEnhance = () => {
  if (!User.getInstance.isLogin.value) {
    $signUpDialog();
    return;
  }

  localStorage.setItem('waitUploadPhotoEnhanceImg', JSON.stringify(currentPicObj.value.imageUrl));
  goRouterPage(RouterPageConst.PhotoEnhancer, locale.value, null, true);
};

</script>
<style lang="scss">
.el-popover.label-tag-popover {

  &>.el-popper__arrow:before {
    background: #2a2a2a !important;
    border: 1px solid #2a2a2a !important;
  }
}

.popperClass {
  padding: 0px !important;

  .popoverItem {
    display: flex;
    // flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 15px 16px;
    border-bottom: 1px solid #eff2fc;
    gap: 10px;

    >img {
      width: 15px;
      height: 15px;
    }

    >svg {
      width: 15px;
      height: 15px;
    }

    >span {
      // margin-left: 10px;
      font-weight: 400;
      font-size: 14px;
      color: #636c86;
    }
  }

  .popoverItem:last-child {
    border: none;
  }

  .popoverItem:hover {
    background: #eff2fc;
    border-radius: 0px 0px 0px 0px;
    // border: 1px solid #eff2fc;
    cursor: pointer;
  }

  .popoverItemReport {
    justify-content: center;
  }
}
</style>
<style lang="scss" scoped>
.triangle {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #FFF;
  border-radius: 3px;
  transition: all .2s;
  /* 红色的向下三角形 */
  &.expand {
    transform: rotate(180deg);
  }
  &.unExpand {
    transform: rotate(0deg);
  }
}


@include LoadingRotation();

.case-item-loading {
  &.-circle {
    margin-left: 10px;
    width: 16px;
    height: 16px;
    border: 2px solid #fff;
    border-bottom-color: rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  &.-samll-circle {
    width: 16px;
    height: 16px;
    border: 2px solid #0d0c22;
    border-bottom-color: rgba(13, 12, 34, 0.5);
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }
}

@keyframes l27 {
  100% {
    transform: rotate(1turn);
  }
}

:deep().el-popover.el-popper {
  padding: 12px 0px;
  border-radius: 10px;
  min-width: fit-content !important;
  cursor: pointer;

  &.download-btn {
    width: 121px !important;
    z-index: 10 !important;

    .download {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      height: 100%;

      span {
        height: 38px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #000000;
        text-align: center;
        font-weight: 400;
        font-size: 18px;
        line-height: 18px;

        // &:hover {
        //   color: #1339F7;
        // }
      }

    }
  }
}

.searchEmptyResult {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f9faff 0%, #e9effd 100%);
  border-radius: 0px 0px 0px 0px;
}

@media (min-width: 1000px) {
  .searchEmptyResult {
    padding: 0px 40px;
  }


  .reportVisibleTitle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-right: 40px;

    .title {
      font-weight: 600;
      font-size: 26px;
      color: #0c062c;
      line-height: 29px;
    }

    .desc {
      margin-top: 14px;
      font-weight: 400;
      font-size: 16px;
      color: #636c86;
    }
  }


  .imagesDetails {

    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // justify-content: center;

    .imageSearch {
      // height: 178px;
      padding-top: 10px;
      padding-bottom: 30px;
      width: 100%;
      background: linear-gradient(180deg, #f9faff 0%, #e9effd 100%);
      border-radius: 0px 0px 0px 0px;
      padding-top: calc(72px + 10px);
      display: flex;
      align-items: center;
      justify-content: center;
      position: sticky;
      top: 0;
      left: 0;
      right: 0;
      z-index: 9;

      .imageSearchInput {
        padding-left: 11px;
        height: 66px;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 824px;
        width: 100%;

        :deep .el-input__wrapper {
          box-shadow: none !important;
        }

        :deep .el-input {
          height: 100%;
          flex: 1;
        }

        :deep .el-input__inner {
          height: 100%;
          font-size: 16px !important;
        }

        :deep .el-input__inner::placeholder {
          font-size: 16px !important;
        }
      }

      .imageSearchAction {
        width: 65px;
        height: 65px;
        background: #2f50fa;
        border-radius: 10px 10px 10px 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        >img {
          width: 22px;
          height: 22px;
        }
      }
    }

    .imageblockpage {
      // flex: 1;
      // height: 100%;
      align-items: center;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      // border-bottom: 1px solid #f4f4f5;
      padding: 0px 40px;
      // padding-top: 178px;
      //   padding-top: 112px;
      //padding: 0px 40px;
      //   // position: relative;

      //   .gap20 {
      //     align-self: stretch;
      //     background-color: #ffffff;
      //     height: 20px;
      //     // position: relative;
      //     width: 100%;
      //   }

      .image-detail-block {
        // align-items: flex-start;
        align-items: stretch;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        gap: 22px;
        max-width: 1400px;
        // position: relative;
        width: 100%;
        margin: 0 auto;
        padding-top: 20px;
        padding-bottom: 49px;
        border-bottom: 1px solid #F4F4F5;
        margin-bottom: 44px;
      }

      .image-area {
        align-items: center;
        align-self: stretch;
        display: flex;
        flex: 1;
        flex-direction: column;
        flex-grow: 1;
        justify-content: center;
        // position: relative;
        // background-color: #636c86;
      }

      .image {
        align-self: stretch;
        flex: 0 0 auto;
        width: 100%;
        max-width: 966px;
        max-height: 589px;
        height: 100%;
        object-fit: contain;
        cursor: zoom-in;
      }

      .emptyimage {
        align-self: stretch;
        flex: 0 0 auto;
        width: 100%;
        height: 100%;
        max-width: 966px;
        max-height: 589px;
        background-color: #eff2fc;
      }

      .image-card {
        align-items: flex-start;
        background-color: #ffffff;
        border: 1px solid;
        border-color: #e6e6e6;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        // position: relative;
        width: 100%;
        max-width: 412px;
      }

      .icon-button-group {
        align-items: center;
        align-self: stretch;
        border-bottom-style: solid;
        border-bottom-width: 1px;
        border-color: #e6e6e6;
        display: flex;
        flex: 0 0 auto;
        justify-content: space-between;
        padding: 30px 30px 22px;
        // position: relative;
        width: 100%;
      }

      .image-area-button {
        display: none;
      }

      .icon-button-group-left {
        align-items: flex-start;
        display: flex;
        flex: 1;
        flex-grow: 1;
        gap: 15px;
        // position: relative;
      }

      .icon-button {
        align-items: center;
        border: 1px solid;
        border-color: #eff2fc;
        border-radius: 10px;
        display: inline-flex;
        flex: 0 0 auto;
        gap: 10px;
        height: 44px;
        justify-content: center;
        padding: 12px 20px;
        // position: relative;
        cursor: pointer;
      }

      .icon-button:hover {
        background: #eff2fc;
      }

      .button-title {
        color: #0d0c22;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: normal;
        margin-top: -0.5px;
        // position: relative;
        white-space: nowrap;
        width: fit-content;
      }

      .icon-button-1 {
        align-items: center;
        border: 1px solid;
        border-color: #eff2fc;
        border-radius: 10px;
        display: inline-flex;
        flex: 0 0 auto;
        gap: 10px;
        height: 44px;
        justify-content: center;
        padding: 12px;
        // position: relative;
        cursor: pointer;
      }

      // .icon-button-1:hover {
      //   background: #eff2fc;
      // }
      @media (any-hover: hover) {
        .icon-button-1:hover {
          background: #eff2fc;
        }
      }

      .icon-1 {
        height: 20px;
        // position: relative;
        width: 20px;
      }

      .button-title-1 {
        color: #0d0c22;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: normal;
        margin-top: -0.5px;
        // position: relative;
        white-space: nowrap;
        width: fit-content;
      }

      .icon-button-2 {
        align-items: center;
        border: 1px solid;
        border-color: #eff2fc;
        border-radius: 10px;
        display: flex;
        height: 44px;
        justify-content: center;
        // position: relative;
        width: 44px;
        cursor: pointer;
      }

      // .icon-button-2:hover {
      //   background: #eff2fc;
      // }
      @media (any-hover: hover) {
        .icon-button-2:hover {
          background: #eff2fc;
        }
      }

      .icon-2 {
        height: 22px;
        // position: relative;
        width: 22px;
      }

      .image-info {
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        // flex: 0 0 auto;
        flex: 1;
        flex-direction: column;
        padding: 19px 30px 30px;
        // position: relative;
        width: 100%;
        position: relative;
      }

      .user-block {
        align-items: center;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        gap: 14px;
        padding: 0px 0px 0px 5px;
        // position: relative;
        width: 100%;
      }

      .user-headshot {
        height: 47px;
        // object-fit: cover;
        // position: relative;
        width: 47px;
        background-repeat: no-repeat;
        background-size: contain;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
      }

      .empty-user-headshot {
        height: 47px;
        -o-object-fit: cover;
        object-fit: cover;
        width: 47px;
        background: #707177;
      }

      .user-info {
        align-items: flex-start;
        display: flex;
        flex: 1;
        flex-direction: column;
        flex-grow: 1;
        gap: 7px;
        // position: relative;
      }

      .user-name {
        align-self: stretch;
        color: #000000;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: normal;
        margin-top: -1px;
        // position: relative;
        cursor: pointer;
      }

      .user-detail {
        align-self: stretch;
        color: #707177;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: normal;
        // position: relative;
      }

      .gap22 {
        align-self: stretch;
        height: 22px;
        // position: relative;
        width: 100%;
      }

      .title {
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        padding: 0px 0px 0px 9px;
        // position: relative;
        width: 100%;
      }

      .image-title {
        font-weight: 400;
        font-size: 15px;
        color: #000000;
        flex: 1;
        letter-spacing: 0;
        line-height: 22px;
        margin-top: -1px;
        // position: relative;
      }

      .gap10 {
        align-self: stretch;
        height: 10px;
        // position: relative;
        width: 100%;
      }

      .prompt-block::-webkit-scrollbar {
        display: none;
        width: 0;
      }

      .prompt-block {
        flex: 1;
        align-items: flex-start;
        align-self: stretch;
        background-color: #f4f5f6;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        // max-height: 218px;
        // height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        padding: 10px;
        // position: relative;
        width: 100%;
      }

      .prompt {
        align-self: stretch;
        height: 198px;
        // height: 100%;
        letter-spacing: 0;
        line-height: 22px;

        // position: relative;
        .sfpro-regular-normal-black-15px {
          font-weight: 600;
          font-size: 15px;
          color: #000000;
          line-height: 22px;
        }

        .sfpro-regular-normal-black-13px {
          font-weight: 400;
          font-size: 13px;
          color: #000000;
          line-height: 22px;
        }
      }

      .gap20-1 {
        align-self: stretch;
        height: 20px;
        // position: relative;
        width: 100%;
      }

      .sub-button-group {
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        gap: 22px;
        // position: relative;
        width: 100%;

        .sub-button {
          align-items: center;
          align-self: stretch;
          background-color: #ffffff;
          border: 1px solid;
          border-color: #577eff;
          border-radius: 10px;
          display: flex;
          gap: 10px;
          justify-content: center;
          padding: 10.5px;
          // position: relative;
          width: 165px;
          cursor: pointer;
        }

        .button-title-2 {
          flex: 1;
          letter-spacing: 0;
          line-height: normal;
          margin-top: -1px;
          // position: relative;
          text-align: center;
        }

        .sub-button.sub-button-1 {
          align-self: unset;
          flex: 1;
          flex-grow: 1;
          width: unset;
        }

        .sfpro-regular-normal-black-15px {
          color: #000000;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
        }

        .sfpro-medium-blue-16px {
          color: #2f4ff9;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
        }
      }

      .gap16 {
        align-self: stretch;
        height: 16px;
        // position: relative;
        width: 100%;
      }

      .primary-button {
        align-items: center;
        align-self: stretch;
        background-color: #2f4ff9;
        border-radius: 10px;
        display: flex;
        flex: 0 0 auto;
        // gap: 10px;
        justify-content: center;
        // padding: 12px 66px;
        // position: relative;
        width: 100%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .download-free {
        color: #ffffff;
        flex: 1;
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 20px;
        margin-top: -1px;
        // position: relative;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }


      .download-type {
        width: 44px;
        height: 44px;
        background: #2F50FA;
        border-radius: 0px 10px 10px 0px;
        border-left: 1px solid #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background: #1339F7;
        }

        .triangle {
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 6px solid #FFF;
          border-radius: 3px;
          transition: all .15s;
          &.expand {
            transform: rotate(180deg);
          }
          &.unExpand {
            transform: rotate(0deg);
          }
        }
      }

      .gap50 {
        display: none;
      }
    }

    .more-pic {
      //   padding-top:44px;
      //   padding-bottom: 33px;
      padding: 44px 40px 33px 40px;
    }

    .more-tags {
      padding: 44px 0px 33px 0px;
      position: relative;
      width: calc(100% - 80px);
      margin: 0 auto;
      max-width: 1400px;
      border-top: 1px solid #f4f5f6;
      z-index: 1;

      .tabLeft {
        padding: 44px 0px 33px 0px;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        z-index: 2;
        cursor: pointer;
        width: 20px;

        >img {
          width: 7px;
          height: auto;
        }
      }

      .tabRight {
        padding: 44px 0px 33px 0px;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        z-index: 2;
        cursor: pointer;
        width: 20px;

        >img {
          width: 7px;
          height: auto;
        }
      }

      .tabListLeftScroll::before {
        // background: linear-gradient(
        //   90deg,
        //   hsla(0, 0%, 100%, 0) 0,
        //   #fff 90%,
        //   #fff
        // );
        background: linear-gradient(270deg,
            hsla(0, 0%, 100%, 0) 0,
            #fff 90%,
            #fff);
        left: 0;
        width: 100px;
        bottom: 0;
        content: "";
        display: block;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        transition: opacity 0.2s ease-in-out;
        z-index: 1;
        opacity: 1;
      }

      .tabListRightScroll::after {
        background: linear-gradient(90deg,
            hsla(0, 0%, 100%, 0) 0,
            #fff 90%,
            #fff);
        right: 0;
        width: 100px;
        bottom: 0;
        content: "";
        display: block;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        transition: opacity 0.2s ease-in-out;
        z-index: 1;
        opacity: 1;
      }

      .tabList {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;
        overflow-y: scroll;

        z-index: -1;
        overflow: scroll hidden;
        scrollbar-width: none;
        -webkit-overflow-scrolling: touch;
        scroll-behavior: smooth;
        // isolation: isolate;

        .tabItem {
          padding: 12px 20px;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #eff2fc;
          cursor: pointer;

          // margin-right: 12px;
          &:hover {
            background: #f5f8ff;
          }
        }
      }
    }

    .categoryListItem {
      padding: 12px 20px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #eff2fc;
      margin-right: 12px;
    }

    // }
    :deep .el-select--large .el-select__wrapper {
      height: 54px;
      border-radius: 10px 10px 10px 10px;
    }

    :deep .el-select__popper {
      :deep .el-select-dropdown__list {
        padding: none;
      }

      :deep .el-select-dropdown__item {
        height: 42px;
        border-radius: 8px 8px 0px 0px;
        border: 1px solid #eff2fc;
      }
    }
  }
}

@media (min-width: 767px) and (max-width: 999px) {
  .searchEmptyResult {
    padding: 0px 40px;
  }

  .reportVisibleTitle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-right: 40px;

    .title {
      font-weight: 600;
      font-size: 26px;
      color: #0c062c;
      line-height: 29px;
    }

    .desc {
      margin-top: 14px;
      font-weight: 400;
      font-size: 16px;
      color: #636c86;
    }
  }

  .imagesDetails {

    .imageSearch {
      // height: 178px;
      // padding-top: 10px;
      padding-bottom: 25px;
      width: 100%;
      background: linear-gradient(180deg, #f9faff 0%, #e9effd 100%);
      border-radius: 0px 0px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: sticky;
      top: 0;
      left: 0;
      right: 0;
      // padding: 0px 15px;
      padding-top: calc(62px + 15px);
      z-index: 9;

      .imageSearchInput {
        padding-left: 11px;
        height: 46px;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 583px;
        width: 100%;

        :deep .el-input__wrapper {
          box-shadow: none !important;
        }

        :deep .el-input {
          height: 100%;
          flex: 1;
        }

        :deep .el-input__inner {
          height: 100%;
          font-size: 16px !important;
        }

        :deep .el-input__inner::placeholder {
          font-size: 16px !important;
        }
      }

      .imageSearchAction {
        width: 46px;
        height: 46px;
        background: #2f50fa;
        border-radius: 10px 10px 10px 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        >img {
          width: 22px;
          height: 22px;
        }
      }
    }


    .imageblockpage {
      align-items: center;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      // border-bottom: 1px solid #f4f4f5;
      padding: 0px 40px;
      // padding-top: 178px;
      //   padding-top: 112px;
      //padding: 0px 40px;
      //   // position: relative;

      //   .gap20 {
      //     align-self: stretch;
      //     background-color: #ffffff;
      //     height: 20px;
      //     // position: relative;
      //     width: 100%;
      //   }

      .image-detail-block {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        gap: 22px;
        max-width: 1400px;
        // position: relative;
        width: 100%;
        margin: 0 auto;
        padding-top: 20px;
        padding-bottom: 26px;
        border-bottom: 1px solid #F4F4F5;
        margin-bottom: 20px;
        // padding: 0 40px;
      }

      .image-area {
        align-items: center;
        align-self: stretch;
        display: flex;
        flex: 1;
        flex-direction: column;
        flex-grow: 1;
        justify-content: center;
        // position: relative;
      }

      //   .image {
      //     align-self: stretch;
      //     flex: 0 0 auto;
      //     // position: relative;
      //     width: 100%;
      //     max-width: 966px;
      //     max-height: 589px;
      //   }
      .image {
        align-self: stretch;
        flex: 0 0 auto;
        // position: relative;
        height: 515px;
        width: 100%;
        // max-width: 919px;
        // max-height: 515px;
        object-fit: contain;
      }

      .emptyimage {
        align-self: stretch;
        flex: 0 0 auto;
        width: 100%;
        height: 100%;
        min-width: 346px;
        max-width: 919px;
        max-height: 516px;
        min-height: 285px;
        background-color: #eff2fc;
      }

      .image-card {
        align-items: flex-start;
        background-color: #ffffff;
        border-top: 1px solid;
        border-color: #e6e6e6;
        border-radius: 0px;
        display: flex;
        flex-direction: column;
        // position: relative;
        width: 100%;
        // max-width: 412px;
      }

      .icon-button-group {
        align-items: center;
        align-self: stretch;
        // border-bottom-style: solid;
        // border-bottom-width: 1px;
        // border-color: #e6e6e6;
        display: flex;
        flex: 0 0 auto;
        justify-content: space-between;
        padding-bottom: 18px;
        // position: relative;
        width: 100%;
        display: none;
      }

      .image-area-button {
        display: flex;
      }

      .icon-button-group-left {
        align-items: flex-start;
        display: flex;
        flex: 1;
        flex-grow: 1;
        gap: 15px;
        // position: relative;
      }

      .icon-button {
        align-items: center;
        border: 1px solid;
        border-color: #eff2fc;
        border-radius: 10px;
        display: inline-flex;
        flex: 0 0 auto;
        gap: 10px;
        height: 44px;
        justify-content: center;
        padding: 12px 20px;
        // position: relative;
        cursor: pointer;
      }

      @include anyHover() {
        .icon-button:hover {
          background: #eff2fc;
        }
      }


      .button-title {
        color: #0d0c22;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: normal;
        margin-top: -0.5px;
        // position: relative;
        white-space: nowrap;
        width: fit-content;
      }

      .icon-button-1 {
        align-items: center;
        border: 1px solid;
        border-color: #eff2fc;
        border-radius: 10px;
        display: inline-flex;
        flex: 0 0 auto;
        gap: 10px;
        height: 44px;
        justify-content: center;
        padding: 12px;
        // position: relative;
        cursor: pointer;
      }

      // .icon-button-1:hover {
      //   background: #eff2fc;
      // }
      @media (any-hover: hover) {
        .icon-button-1:hover {
          background: #eff2fc;
        }
      }

      .icon-1 {
        height: 20px;
        // position: relative;
        width: 20px;
      }

      .button-title-1 {
        color: #0d0c22;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: normal;
        margin-top: -0.5px;
        // position: relative;
        white-space: nowrap;
        width: fit-content;
      }

      .icon-button-2 {
        align-items: center;
        border: 1px solid;
        border-color: #eff2fc;
        border-radius: 10px;
        display: flex;
        height: 44px;
        justify-content: center;
        // position: relative;
        width: 44px;
        cursor: pointer;
      }

      // .icon-button-2:hover {
      //   background: #eff2fc;
      // }
      @media (any-hover: hover) {
        .icon-button-2:hover {
          background: #eff2fc;
        }
      }

      .icon-2 {
        height: 22px;
        // position: relative;
        width: 22px;
      }

      .image-info {
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        flex-direction: column;
        padding: 19px 0px 0px;
        // position: relative;
        width: 100%;
      }

      .user-block {
        align-items: center;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        gap: 14px;
        padding: 0px 0px 0px 5px;
        // position: relative;
        width: 100%;
      }

      .user-headshot {
        height: 47px;
        // object-fit: cover;
        // position: relative;
        width: 47px;
        background-repeat: no-repeat;
        background-size: contain;
        border-radius: 50%;
        overflow: hidden;
      }

      .empty-user-headshot {
        height: 47px;
        -o-object-fit: cover;
        object-fit: cover;
        width: 47px;
        background: #707177;
      }

      .user-info {
        align-items: flex-start;
        display: flex;
        flex: 1;
        flex-direction: column;
        flex-grow: 1;
        gap: 7px;
        // position: relative;
      }

      .user-name {
        align-self: stretch;
        color: #000000;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: normal;
        margin-top: -1px;
        // position: relative;
      }

      .user-detail {
        align-self: stretch;
        color: #707177;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: normal;
        // position: relative;
      }

      .gap22 {
        align-self: stretch;
        height: 22px;
        // position: relative;
        width: 100%;
      }

      .title {
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        padding: 0px 0px 0px 9px;
        // position: relative;
        width: 100%;
      }

      .image-title {
        font-weight: 400;
        font-size: 15px;
        color: #000000;
        flex: 1;
        letter-spacing: 0;
        line-height: 22px;
        margin-top: -1px;
        // position: relative;
      }

      .gap10 {
        align-self: stretch;
        height: 10px;
        // position: relative;
        width: 100%;
      }

      .prompt-block::-webkit-scrollbar {
        display: none;
        width: 0;
      }

      .prompt-block {
        align-items: flex-start;
        align-self: stretch;
        background-color: #f4f5f6;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        // max-height: 218px;
        height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        padding: 10px;
        // position: relative;
        width: 100%;
      }

      .prompt {
        align-self: stretch;
        max-height: 198px;
        height: 100%;
        letter-spacing: 0;
        line-height: 22px;

        // position: relative;
        .sfpro-regular-normal-black-15px {
          font-weight: 600;
          font-size: 15px;
          color: #000000;
          line-height: 22px;
        }

        .sfpro-regular-normal-black-13px {
          font-weight: 400;
          font-size: 13px;
          color: #000000;
          line-height: 22px;
        }
      }

      .gap20-1 {
        align-self: stretch;
        height: 20px;
        // position: relative;
        width: 100%;
      }

      .sub-button-group {
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        gap: 22px;
        // position: relative;
        width: 100%;

        .sub-button {
          align-items: center;
          align-self: stretch;
          background-color: #ffffff;
          border: 1px solid;
          border-color: #577eff;
          border-radius: 10px;
          display: flex;
          gap: 10px;
          justify-content: center;
          padding: 10.5px;
          // position: relative;
          width: 165px;
          cursor: pointer;
        }

        .button-title-2 {
          flex: 1;
          letter-spacing: 0;
          line-height: normal;
          margin-top: -1px;
          // position: relative;
          text-align: center;
        }

        .sub-button.sub-button-1 {
          align-self: unset;
          flex: 1;
          flex-grow: 1;
          width: unset;
        }

        .sfpro-regular-normal-black-15px {
          color: #000000;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
        }

        .sfpro-medium-blue-16px {
          color: #2f4ff9;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
        }
      }

      .gap16 {
        align-self: stretch;
        height: 16px;
        // position: relative;
        width: 100%;
      }

      .primary-button {
        align-items: center;
        align-self: stretch;
        background-color: #2f4ff9;
        border-radius: 10px;
        flex: 0 0 auto;
        // gap: 10px;
        justify-content: center;
        padding: 12px 66px;
        // position: relative;
        width: 100%;
        cursor: pointer;
        display: none;
      }

      .download-free {
        color: #ffffff;
        flex: 1;
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 20px;
        margin-top: -1px;
        // position: relative;
        text-align: center;
        height: 100%;
      }

      .gap50 {
        display: none;
      }
    }

    .more-pic {
      //   padding-top:44px;
      //   padding-bottom: 33px;
      padding: 44px 40px 33px 40px;
    }

    .more-tags {
      padding: 21px 0px 20px 0px;
      position: relative;
      width: calc(100% - 80px);
      margin: 0 auto;
      max-width: 1400px;
      border-top: 1px solid #f4f5f6;
      z-index: 1;

      .tabLeft {
        padding: 21px 0px 20px 0px;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        z-index: 2;
        width: 20px;
        cursor: pointer;

        >img {
          width: 7px;
          height: auto;
        }
      }

      .tabRight {
        padding: 21px 0px 20px 0px;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        z-index: 2;
        cursor: pointer;
        width: 20px;

        >img {
          width: 7px;
          height: auto;
        }
      }

      .tabListLeftScroll::before {
        // background: linear-gradient(
        //   90deg,
        //   hsla(0, 0%, 100%, 0) 0,
        //   #fff 90%,
        //   #fff
        // );
        background: linear-gradient(270deg,
            hsla(0, 0%, 100%, 0) 0,
            #fff 90%,
            #fff);
        left: 0;
        width: 100px;
        bottom: 0;
        content: "";
        display: block;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        transition: opacity 0.2s ease-in-out;
        z-index: 1;
        opacity: 1;
      }

      .tabListRightScroll::after {
        background: linear-gradient(90deg,
            hsla(0, 0%, 100%, 0) 0,
            #fff 90%,
            #fff);
        right: 0;
        width: 100px;
        bottom: 0;
        content: "";
        display: block;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        transition: opacity 0.2s ease-in-out;
        z-index: 1;
        opacity: 1;
      }

      .tabList {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;
        overflow-y: scroll;

        z-index: -1;
        overflow: scroll hidden;
        scrollbar-width: none;
        -webkit-overflow-scrolling: touch;
        scroll-behavior: smooth;
        // isolation: isolate;

        .tabItem {
          padding: 12px 20px;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #eff2fc;
          cursor: pointer;

          // margin-right: 12px;
          &:hover {
            background: #f5f8ff;
          }
        }
      }
    }

    .categoryListItem {
      padding: 12px 20px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #eff2fc;
      margin-right: 12px;
    }

    // }
    :deep .el-select--large .el-select__wrapper {
      height: 54px;
      border-radius: 10px 10px 10px 10px;
    }

    :deep .el-select__popper {
      :deep .el-select-dropdown__list {
        padding: none;
      }

      :deep .el-select-dropdown__item {
        height: 42px;
        border-radius: 8px 8px 0px 0px;
        border: 1px solid #eff2fc;
      }
    }
  }
}

@media (max-width: 767px) {
  .searchEmptyResult {
    padding: 0px 15px;
  }

  .reportVisibleTitle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-right: 15px;

    .title {
      font-weight: 600;
      font-size: 18px;
      color: #0C062C;
      line-height: 20px;
    }

    .desc {
      font-weight: 400;
      font-size: 12px;
      color: #636C86;
      line-height: 15px;
      margin-top: 7px;
    }
  }

  .imagesDetails {

    .imageSearch {
      // height: 178px;
      // padding-top: 10px;
      // padding-bottom: 25px;
      width: 100%;
      background: linear-gradient(180deg, #f9faff 0%, #e9effd 100%);
      border-radius: 0px 0px 0px 0px;

      display: flex;
      align-items: center;
      justify-content: center;
      //
      // padding-top: calc(60px + 15px);
      padding: calc(60px + 15px) 28px 25px 28px;
      position: sticky;
      top: 0;
      left: 0;
      right: 0;
      z-index: 9;

      .imageSearchInput {
        // padding-left: 11px;
        height: 46px;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 583px;
        min-width: 319px;
        width: 100%;

        :deep .el-input__wrapper {
          box-shadow: none !important;
        }

        :deep .el-input {
          height: 100%;
          flex: 1;
        }

        :deep .el-input__inner {
          height: 100%;
          font-size: 16px !important;
        }

        :deep .el-input__inner::placeholder {
          font-size: 16px !important;
        }
      }

      .imageSearchAction {
        width: 46px;
        height: 46px;
        background: #2f50fa;
        border-radius: 10px 10px 10px 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        >img {
          width: 22px;
          height: 22px;
        }
      }
    }


    .imageblockpage {
      align-items: center;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      padding: 0px 15px;
      // padding-top: 178px;
      //padding: 0px 40px;
      // position: relative;
      //   padding-top: 64px;
      //   .gap20 {
      //     align-self: stretch;
      //     background-color: #ffffff;
      //     height: 20px;
      //     // position: relative;
      //     width: 100%;
      //   }

      .image-detail-block {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        gap: 22px;
        max-width: 1400px;
        // position: relative;
        width: 100%;
        margin: 0 auto;
        // padding-top: 20px;
        padding-bottom: 3px;
        border-bottom: 1px solid #F4F4F5;
        margin-bottom: 20px;
        // padding: 0 40px;
      }

      .image-area {
        align-items: center;
        align-self: stretch;
        display: flex;
        flex: 1;
        flex-direction: column;
        flex-grow: 1;
        justify-content: center;
        // position: relative;
      }

      //   .image {
      //     align-self: stretch;
      //     flex: 0 0 auto;
      //     // position: relative;
      //     width: 100%;
      //   }
      .image {
        align-self: stretch;
        flex: 0 0 auto;
        // position: relative;
        width: 100%;
        // max-width: 346px;
        // max-height: 285px;
        height: 285px;
        object-fit: contain;
      }

      .emptyimage {
        align-self: stretch;
        flex: 0 0 auto;
        width: 100%;
        height: 100%;
        // max-width: 346px;
        min-width: 346px;
        max-height: 516px;
        min-height: 285px;
        background-color: #eff2fc;
      }

      .image-card {
        align-items: flex-start;
        background-color: #ffffff;
        border-top: 1px solid;
        // border-bottom: 1px solid;
        border-color: #e6e6e6;
        // border-radius: 10px;
        display: flex;
        flex-direction: column;
        // position: relative;
        width: 100%;
        // max-width: 100%;
      }

      .icon-button-group {
        align-items: center;
        align-self: stretch;
        // border-bottom-style: solid;
        // border-bottom-width: 1px;
        // border-color: #e6e6e6;
        display: flex;
        flex: 0 0 auto;
        justify-content: space-between;
        padding: 18px 0px;
        // position: relative;
        width: 100%;
        display: none;
      }

      .image-area-button {
        display: flex;
      }

      .icon-button-group-left {
        align-items: flex-start;
        display: flex;
        flex: 1;
        flex-grow: 1;
        gap: 15px;
        // position: relative;
      }

      .icon-button {
        align-items: center;
        border: 1px solid;
        border-color: #eff2fc;
        border-radius: 10px;
        display: inline-flex;
        flex: 0 0 auto;
        gap: 10px;
        height: 44px;
        justify-content: center;
        padding: 12px 20px;
        // position: relative;
        cursor: pointer;
      }

      // .icon-button:hover {
      //   background: #eff2fc;
      // }

      // .icon-button-favorite:hover {
      //   background: initial;
      // }

      @media (any-hover: hover) {
        .icon-button:hover {
          background: #eff2fc;
        }

        .icon-button-favorite:hover {
          background: initial;
        }
      }

      .button-title {
        color: #0d0c22;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: normal;
        margin-top: -0.5px;
        // position: relative;
        white-space: nowrap;
        width: fit-content;
      }

      .icon-button-1 {
        align-items: center;
        border: 1px solid;
        border-color: #eff2fc;
        border-radius: 10px;
        display: inline-flex;
        flex: 0 0 auto;
        gap: 10px;
        height: 44px;
        justify-content: center;
        padding: 12px;
        // position: relative;
        cursor: pointer;
      }

      // .icon-button-1:hover {
      //   background: #eff2fc;
      // }

      @media (any-hover: hover) {
        .icon-button-1:hover {
          background: #eff2fc;
        }
      }

      .icon-1 {
        height: 20px;
        // position: relative;
        width: 20px;
      }

      .button-title-1 {
        color: #0d0c22;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: normal;
        margin-top: -0.5px;
        // position: relative;
        white-space: nowrap;
        width: fit-content;
      }

      .icon-button-2 {
        align-items: center;
        border: 1px solid;
        border-color: #eff2fc;
        border-radius: 10px;
        display: flex;
        height: 44px;
        justify-content: center;
        // position: relative;
        width: 44px;
        cursor: pointer;
      }

      // .icon-button-2:hover {
      //   background: #eff2fc;
      // }
      @media (any-hover: hover) {
        .icon-button-2:hover {
          background: #eff2fc;
        }
      }

      .icon-2 {
        height: 22px;
        // position: relative;
        width: 22px;
      }

      .image-info {
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        flex-direction: column;
        padding: 12px 0px 23px 0px;
        // position: relative;
        width: 100%;
      }

      .user-block {
        align-items: center;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        gap: 14px;
        padding: 0px 0px 0px 5px;
        // position: relative;
        width: 100%;
      }

      .user-headshot {
        height: 47px;
        // object-fit: cover;
        // position: relative;
        width: 47px;
        background-repeat: no-repeat;
        background-size: contain;
        border-radius: 50%;
        overflow: hidden;
      }

      .empty-user-headshot {
        height: 47px;
        -o-object-fit: cover;
        object-fit: cover;
        width: 47px;
        background: #707177;
      }

      .user-info {
        align-items: flex-start;
        display: flex;
        flex: 1;
        flex-direction: column;
        flex-grow: 1;
        gap: 7px;
        // position: relative;
      }

      .user-name {
        align-self: stretch;
        color: #000000;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: normal;
        margin-top: -1px;
        // position: relative;
      }

      .user-detail {
        align-self: stretch;
        color: #707177;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: normal;
        // position: relative;
      }

      .gap22 {
        align-self: stretch;
        height: 22px;
        // position: relative;
        width: 100%;
      }

      .title {
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        padding: 0px 0px 0px 9px;
        // position: relative;
        width: 100%;
      }

      .image-title {
        font-weight: 400;
        font-size: 15px;
        color: #000000;
        flex: 1;
        letter-spacing: 0;
        line-height: 22px;
        margin-top: -1px;
        // position: relative;
      }

      .gap10 {
        align-self: stretch;
        height: 10px;
        // position: relative;
        width: 100%;
      }

      .prompt-block::-webkit-scrollbar {
        display: none;
        width: 0;
      }

      .prompt-block {
        align-items: flex-start;
        align-self: stretch;
        background-color: #f4f5f6;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        // height: 218px;
        // min-height: 218px;
        height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        padding: 10px;
        // position: relative;
        width: 100%;
      }

      .prompt {
        align-self: stretch;
        max-height: 198px;
        height: 100%;
        letter-spacing: 0;
        line-height: 22px;

        // position: relative;
        .sfpro-regular-normal-black-15px {
          font-weight: 600;
          font-size: 15px;
          color: #000000;
          line-height: 22px;
        }

        .sfpro-regular-normal-black-13px {
          font-weight: 400;
          font-size: 13px;
          color: #000000;
          line-height: 22px;
        }
      }

      .gap20-1 {
        align-self: stretch;
        height: 20px;
        // position: relative;
        width: 100%;
      }

      .sub-button-group {
        align-items: flex-start;
        align-self: stretch;
        display: flex;
        flex: 0 0 auto;
        gap: 22px;
        // position: relative;
        width: 100%;

        .sub-button {
          align-items: center;
          align-self: stretch;
          background-color: #ffffff;
          border: 1px solid;
          border-color: #577eff;
          border-radius: 10px;
          display: flex;
          gap: 10px;
          justify-content: center;
          padding: 10.5px;
          // position: relative;
          width: 165px;
          cursor: pointer;
        }

        .button-title-2 {
          flex: 1;
          letter-spacing: 0;
          line-height: normal;
          margin-top: -1px;
          // position: relative;
          text-align: center;
        }

        .sub-button.sub-button-1 {
          align-self: unset;
          flex: 1;
          flex-grow: 1;
          width: unset;
        }

        .sfpro-regular-normal-black-15px {
          color: #000000;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
        }

        .sfpro-medium-blue-16px {
          color: #2f4ff9;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
        }
      }

      .gap16 {
        align-self: stretch;
        height: 16px;
        // position: relative;
        width: 100%;
        display: none;
      }

      .primary-button {
        align-items: center;
        align-self: stretch;
        background-color: #2f4ff9;
        border-radius: 10px;
        display: flex;
        flex: 0 0 auto;
        // gap: 10px;
        justify-content: center;
        padding: 12px 66px;
        // position: relative;
        width: 100%;
        display: none;
      }

      .download-free {
        color: #ffffff;
        flex: 1;
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 20px;
        margin-top: -1px;
        // position: relative;
        text-align: center;
        height: 100%;
      }

      .gap50 {
        display: none;
      }
    }

    .more-pic {
      //   padding-top:44px;
      //   padding-bottom: 33px;
      padding: 44px 15px 33px 15px;
    }

    .more-tags {
      padding: 21px 0px 20px 0px;
      position: relative;
      width: calc(100% - 30px);
      margin: 0 auto;
      max-width: 1400px;
      border-top: 1px solid #f4f5f6;
      z-index: 1;

      .tabLeft {
        padding: 21px 0px 20px 0px;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        z-index: 2;
        cursor: pointer;
        width: 20px;

        >img {
          width: 7px;
          height: auto;
        }
      }

      .tabRight {
        padding: 21px 0px 20px 0px;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        z-index: 2;
        cursor: pointer;
        width: 20px;

        >img {
          width: 7px;
          height: auto;
        }
      }

      .tabListLeftScroll::before {
        // background: linear-gradient(
        //   90deg,
        //   hsla(0, 0%, 100%, 0) 0,
        //   #fff 90%,
        //   #fff
        // );
        background: linear-gradient(270deg,
            hsla(0, 0%, 100%, 0) 0,
            #fff 90%,
            #fff);
        left: 0;
        width: 100px;
        bottom: 0;
        content: "";
        display: block;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        transition: opacity 0.2s ease-in-out;
        z-index: 1;
        opacity: 1;
      }

      .tabListRightScroll::after {
        background: linear-gradient(90deg,
            hsla(0, 0%, 100%, 0) 0,
            #fff 90%,
            #fff);
        right: 0;
        width: 100px;
        bottom: 0;
        content: "";
        display: block;
        opacity: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        transition: opacity 0.2s ease-in-out;
        z-index: 1;
        opacity: 1;
      }

      .tabList {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;
        overflow-y: scroll;

        z-index: -1;
        overflow: scroll hidden;
        scrollbar-width: none;
        -webkit-overflow-scrolling: touch;
        scroll-behavior: smooth;
        // isolation: isolate;

        .tabItem {
          padding: 12px 20px;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #eff2fc;
          cursor: pointer;

          // margin-right: 12px;
          &:hover {
            background: #f5f8ff;
          }
        }
      }
    }

    .categoryListItem {
      padding: 12px 20px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #eff2fc;
      margin-right: 12px;
    }

    :deep .el-select--large .el-select__wrapper {
      height: 54px;
      border-radius: 10px 10px 10px 10px;
    }
  }
}

.icon {
  width: 21px;
  color: #fff;

  :deep(path) {
    stroke: #000;
  }

  &.is-favorite {
    color: #D93134;

    :deep(path) {
      stroke: #D93134;
    }
  }
}

.scroll-tag-warpper {

  @include responseTo(pc-1000px) {
    margin-bottom: 33px;
  }

  @include responseTo(web-999px) {
    margin-bottom: 20px;
  }
}

.content-container {
  @include responseTo(pc-1000px) {
    padding-bottom: 50px;
  }

  @include responseTo(web-999px) {
    padding-bottom: 30px;
  }
}

.top-right {
  top: 16px;
  right: 16px;
  position: absolute;

  @media (max-width: 767px) {
    top: 16px;
    right: 10px;
  }

  // pointer-events: none;
}

.d-img {
  width: 24px;
  height: 24px;
  cursor: pointer;
  padding: 2px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 5px 5px 5px 5px;
  // pointer-events: none;
}

.more-format-btn:last-child {
  margin-bottom: 0;
}

:deep() .more-format-btn-text {
  font-family:
    SFPro,
    PingFang SC,
    Hiragino Sans GB,
    Microsoft YaHei,
    Arial,
    sans-serif;
}

.more-format-btn {
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  justify-content: left;
  padding: 10px;
  color: #333B52;
  margin-bottom: 10px;
  font-family:
    SFPro,
    PingFang SC,
    Hiragino Sans GB,
    Microsoft YaHei,
    Arial,
    sans-serif;


  @media (any-hover: hover) {
    &:hover {
      color: rgba(19, 57, 247, 1);
      background: #f5f8ff;
      border-radius: 5px;
    }
  }

  &:active {
    color: rgba(19, 57, 247, 1);
    background: #f5f8ff;
    border-radius: 5px;
  }

  &-img {
    width: 20px;
    height: 20px;
  }

  &-text {
    margin-left: 10px;

    font-weight: 400;
    font-size: 16px;
    color: #333B52;
    line-height: 16px;
    text-align: left;
    text-transform: none;

    white-space: nowrap;
  }
}


@media (any-hover: hover) {
  .download span:hover {
    background: #F5F8FF;
    // color: #1339F7 !important;
  }

  .download-free span:hover {
    // background: #F5F8FF;
    // color: #1339F7 !important;
  }

  .download-free {
    &:hover {
      border-radius: 10px 0px 0px 10px;
      background: #1339F7;
      // color: #1339F7 !important;
      // color: #1339F7;
      // >span:hover{
      //   color: #1339F7 !important;
      // }
    }
  }

  // .download-type {
  //   // background: #1339F7;
  //   &:hover {
  //     // background: #1339F7;
  //   }
  // }
}
</style>
